import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { FullScreenContainer } from 'src/Home/AdditionalDetail/MobileView/FullScreenDetails/FullScreenContainer'

export const AdditionalDetails = (props: RouteComponentProps) => {
  return <FullScreenContainer props={props} />
}
